/* global React */
// `Icon` below is a stateless presentational component; the file does not
// destructure React hooks. The `/* global React */` comment is retained so
// JSX (which compiles to `React.createElement(...)` under the legacy
// no-bundle Babel-Standalone runtime) can resolve the React identifier at
// runtime. Phase C replaces this with an ES-module import.

// Line icons, 1.5 stroke, 24x24
const Icon = ({ name, size = 20, color = "currentColor", stroke = 1.5 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  const paths = {
    arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
    check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
    spark: (
      <>
        <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8" />
      </>
    ),
    play: <path d="M8 5v14l11-7z" fill="currentColor" stroke="none" />,
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    shield: <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />,
    lock: (
      <>
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V8a4 4 0 018 0v3" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" />
      </>
    ),
    chart: (
      <>
        <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
      </>
    ),
    user: (
      <>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="4" />
        <path d="M1 21c0-4 3.5-7 8-7s8 3 8 7" />
        <path d="M16 4a4 4 0 010 8M22 21c0-3-2-5-5-6" />
      </>
    ),
    chat: <path d="M4 5h16v11H9l-5 4V5z" />,
    bell: (
      <>
        <path d="M6 9a6 6 0 0112 0v5l2 3H4l2-3V9z" />
        <path d="M10 20a2 2 0 004 0" />
      </>
    ),
    calendar: (
      <>
        <rect x="3.5" y="5.5" width="17" height="15" rx="2" />
        <path d="M8 3v4M16 3v4M3.5 10h17" />
      </>
    ),
    phone: (
      <path d="M4 5c0 9 6 15 15 15l1.5-3.5-4-2-2.2 1.5a13 13 0 01-5.3-5.3L10.5 8.5l-2-4L5 6" />
    ),
    card: (
      <>
        <rect x="3" y="6" width="18" height="13" rx="2" />
        <path d="M3 11h18M7 15h4" />
      </>
    ),
    building: (
      <>
        <rect x="4" y="3" width="16" height="18" rx="1.5" />
        <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2" />
      </>
    ),
    zap: <path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z" />,
    mail: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 7l9 7 9-7" />
      </>
    ),
    menu: <path d="M4 7h16M4 12h16M4 17h16" />,
    x: <path d="M5 5l14 14M19 5L5 19" />,
    plus: <path d="M12 5v14M5 12h14" />,
    chevDown: <path d="M6 9l6 6 6-6" />,
    send: <path d="M21 3L3 11l7 2 2 7 9-17z" />,
    tg: <path d="M21.5 4L2.5 11.4l5.5 2 2 6 3.5-3.5 5 4L21.5 4z" />,
    mic: (
      <>
        <rect x="9.5" y="3" width="5" height="11" rx="2.5" />
        <path d="M6 11a6 6 0 0012 0M12 17v4" />
      </>
    ),
    heart: <path d="M12 20s-8-5-8-11a5 5 0 019-3 5 5 0 019 3c0 6-8 11-8 11z" />,
    stethoscope: (
      <>
        <path d="M4 3v6a4 4 0 008 0V3M6 21a5 5 0 005-5v-3" />
        <circle cx="18" cy="10" r="2" />
        <path d="M18 12v2a5 5 0 01-5 5" />
      </>
    ),
    target: (
      <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      </>
    ),
    tooth: (
      <path d="M12 3c-3 0-6 2-6 6 0 4 1.5 5 2 8 .3 2 .8 4 2 4s1.7-2 2-4c0 0 .3-2 2-2s1.7 2 2 4c.3 2 .8 4 2 4s1.7-2 2-4c.5-3 2-4 2-8 0-4-3-6-6-6-1.5 0-2 1-2 1s-.5-1-2-1z" />
    ),
    eye: (
      <>
        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    baby: (
      <>
        <circle cx="12" cy="8" r="3" />
        <path d="M6 20c0-4 3-6 6-6s6 2 6 6M10 18v3M14 18v3" />
      </>
    ),
    flask: <path d="M9 3h6v4l4 10a3 3 0 01-3 4H8a3 3 0 01-3-4l4-10V3zM8 14h8" />,
    pill: (
      <>
        <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-30 12 12)" />
        <path d="M10.5 7.5l3 9" />
      </>
    ),
    video: (
      <>
        <rect x="3" y="6" width="13" height="12" rx="2" />
        <path d="M16 10l5-3v10l-5-3z" />
      </>
    ),
    filePdf: (
      <>
        <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9l-6-6z" />
        <path d="M14 3v6h6" />
      </>
    ),
    trend: <path d="M3 17l6-6 4 4 8-8M15 7h6v6" />,
    money: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M8 14c0 1.7 2 3 4 3s4-1 4-2.5-2-2-4-2.5-4-1-4-2.5 2-2.5 4-2.5 4 1 4 2.5M12 6v12" />
      </>
    ),
    warning: (
      <>
        <path d="M12 3L2 20h20L12 3z" />
        <path d="M12 10v5M12 18v.5" />
      </>
    ),
    briefcase: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M9 7V5a2 2 0 012-2h2a2 2 0 012 2v2M3 13h18" />
      </>
    ),
    sparkle: <path d="M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z" />,
    night: <path d="M20 14a8 8 0 01-10-10 8 8 0 1010 10z" />,
    flag: <path d="M5 21V4M5 4h12l-2 4 2 4H5" />,
  };
  return <svg {...common}>{paths[name] || null}</svg>;
};

window.Icon = Icon;
